import haWrapper from './haWrapper';

/**
 * Wrapped fetch post which correctly accounts for CSRF protection
 *
 * @param {string} url endpoint URL
 * @param {object} data POST payload
 */
export function post(url, data) {
    return fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            Accept: 'application/json, text/plain, */*',
            'Content-Type': 'application/json;charset=UTF-8',
            'x-csrf-token': haWrapper.crumb
        },
        body: JSON.stringify(data)
    });
}
